@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';
@import '../../styles/mixins.scss';
@import '../../styles/deviceBreakpoints.scss';
@import '../../styles/screenReader.scss';

.warning {
  background-color: _palette(warning-2);
}

.mobileFriendlyTable {
  @include target(mobile) {
    table,
    thead,
    tbody,
    th {
      display: block;
    }

    thead tr {
      @include screenReaderOnly();
    }

    tr {
      display: table-row-group;
    }

    td {
      display: table-row;

      button {
        max-width: 100%;
        min-width: 100%;
      }
    }

    td > span {
      border: 0.0625rem solid #eee;
      display: table-cell;
      padding: 0.4375rem 0.8125em;
    }

    .hiddenHeader {
      font-weight: 600;
    }

    td > span:nth-child(2) {
      width: 100%;
    }
  }

  .caption {
    caption-side: top;
    padding: 0;
  }

  th {
    border-bottom: solid 0.0625rem _palette(black-25);
    box-shadow: 0 2px 1px -1px _palette(black-25);
    font-size: 1rem;
    font-weight: 600;
  }

  tbody {
    tr:nth-child(odd) {
      background-color: _palette(text-white-secondary);
    }

    tr:nth-child(even) {
      background-color: _palette(bg-primary);
    }

    td {
      border-bottom: solid 0.0625rem _palette(border-black-10);
      box-shadow: 0 2px 1px -1px _palette(border-black-10);
    }

    tr:last-of-type > td {
      border-bottom: solid 0.0625rem _palette(black-25);
      box-shadow: 0 2px 1px -1px _palette(black-25);
    }

    tr:hover {
      background-color: _palette(bg-secondary);

      td {
        color: _palette(text-data-changed);
      }
    }
  }
}
